import { __assign, __awaiter, __generator } from "tslib";
import { guidToInt } from '../../utils/guidToInt';
import { getImageUrl } from '@wix/sdk/media';
import { BOOKINGS_APP_DEF_ID } from '@wix/wixstores-client-core';
import { SPECS } from '../../constants';
export function getLeanGQLCartFromSDK(currentCartService, siteStore, cart) {
    var _a;
    return __awaiter(this, void 0, void 0, function () {
        var _b;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    if (!(cart !== null && cart !== void 0)) return [3 /*break*/, 1];
                    _b = cart;
                    return [3 /*break*/, 3];
                case 1: return [4 /*yield*/, currentCartService.getCurrentCart()];
                case 2:
                    _b = (_c.sent());
                    _c.label = 3;
                case 3:
                    cart = _b;
                    if (!(((_a = cart.lineItems) === null || _a === void 0 ? void 0 : _a.some(function (lineItem) { var _a; return ((_a = lineItem.catalogReference) === null || _a === void 0 ? void 0 : _a.appId) === BOOKINGS_APP_DEF_ID; })) &&
                        !siteStore.experiments.enabled(SPECS.DontUseLineItemEnricherInCartAndCheckout))) return [3 /*break*/, 5];
                    return [4 /*yield*/, currentCartService.getCurrentCartGQL()];
                case 4: return [2 /*return*/, (_c.sent())];
                case 5: return [2 /*return*/, mapCartToLeanGQLCartModel(cart)];
            }
        });
    });
}
function mapCartToLeanGQLCartModel(cart) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k;
    var coupon = (_b = (_a = cart.appliedDiscounts) === null || _a === void 0 ? void 0 : _a.find(function (discount) { return discount.coupon; })) === null || _b === void 0 ? void 0 : _b.coupon;
    var appliedDiscounts = mapLineItemIdToRules(cart.appliedDiscounts);
    return {
        cartId: cart._id,
        items: ((_c = cart.lineItems) !== null && _c !== void 0 ? _c : []).map(function (lineItem) {
            return mapLineItemToLeanLineItemModel(lineItem, appliedDiscounts[lineItem._id]);
        }),
        convertedTotals: {
            itemsTotal: ((_d = cart.subtotal) === null || _d === void 0 ? void 0 : _d.convertedAmount) ? Number(cart.subtotal.convertedAmount) : undefined,
            formattedItemsTotal: (_e = cart.subtotal) === null || _e === void 0 ? void 0 : _e.formattedConvertedAmount,
            discount: ((_f = cart.discount) === null || _f === void 0 ? void 0 : _f.convertedAmount) ? Number(cart.discount.convertedAmount) : undefined,
            subTotal: ((_g = cart.subtotal) === null || _g === void 0 ? void 0 : _g.convertedAmount) ? Number(cart.subtotal.convertedAmount) : undefined,
            shipping: 0,
            tax: 0,
            total: ((_h = cart.subtotalAfterDiscounts) === null || _h === void 0 ? void 0 : _h.convertedAmount)
                ? Number(cart.subtotalAfterDiscounts.convertedAmount)
                : undefined,
        },
        convertedCurrencyFormat: { code: cart.conversionCurrency },
        buyerNote: (_j = cart.buyerNote) !== null && _j !== void 0 ? _j : null,
        appliedCoupon: coupon
            ? {
                couponId: coupon._id,
                code: coupon.code,
                name: coupon.code,
                convertedDiscountValue: (_k = cart.discount) === null || _k === void 0 ? void 0 : _k.formattedConvertedAmount,
            }
            : undefined,
    };
}
function mapLineItemToLeanLineItemModel(lineItem, appliedDiscounts) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s;
    var fileType = (_b = (_a = lineItem.digitalFile) === null || _a === void 0 ? void 0 : _a.fileType) === null || _b === void 0 ? void 0 : _b.toLowerCase();
    var comparePrice = ((_c = lineItem.fullPrice) === null || _c === void 0 ? void 0 : _c.formattedConvertedAmount) !== ((_d = lineItem.price) === null || _d === void 0 ? void 0 : _d.formattedConvertedAmount)
        ? lineItem.fullPrice
        : undefined;
    var formattedPriceBeforeDiscount = ((_e = lineItem.priceBeforeDiscounts) === null || _e === void 0 ? void 0 : _e.formattedConvertedAmount) !== ((_f = lineItem.price) === null || _f === void 0 ? void 0 : _f.formattedConvertedAmount)
        ? (_g = lineItem.priceBeforeDiscounts) === null || _g === void 0 ? void 0 : _g.formattedConvertedAmount
        : '';
    var product = mapLineItemToProduct(lineItem);
    return __assign(__assign({ cartItemId: guidToInt(lineItem._id), quantity: lineItem.quantity, inventoryQuantity: (_j = (_h = lineItem.availability) === null || _h === void 0 ? void 0 : _h.quantityAvailable) !== null && _j !== void 0 ? _j : null, productId: (_k = lineItem.catalogReference) === null || _k === void 0 ? void 0 : _k.catalogItemId, catalogAppId: (_l = lineItem.catalogReference) === null || _l === void 0 ? void 0 : _l.appId, optionsSelectionsValues: getOptionsSelectionsValues(lineItem, product.customTextFields), product: product, sku: (_o = (_m = lineItem.physicalProperties) === null || _m === void 0 ? void 0 : _m.sku) !== null && _o !== void 0 ? _o : '', convertedPrices: {
            formattedPrice: (_p = lineItem.price) === null || _p === void 0 ? void 0 : _p.formattedConvertedAmount,
            formattedComparePrice: (_q = comparePrice === null || comparePrice === void 0 ? void 0 : comparePrice.formattedConvertedAmount) !== null && _q !== void 0 ? _q : '',
            formattedPriceBeforeDiscount: formattedPriceBeforeDiscount,
            totalPrice: ((_r = lineItem.lineItemPrice) === null || _r === void 0 ? void 0 : _r.convertedAmount) ? Number(lineItem.lineItemPrice.convertedAmount) : 0,
        }, comparePrice: (comparePrice === null || comparePrice === void 0 ? void 0 : comparePrice.amount) ? Number(comparePrice.amount) : 0, discountRules: appliedDiscounts ? appliedDiscounts.map(function (name) { return ({ name: name }); }) : [], urlPart: (_s = lineItem.url) === null || _s === void 0 ? void 0 : _s.split('/').pop(), digitalProductFileItems: fileType ? [{ fileType: fileType }] : [] }, product), { media: product.media[0] });
}
function mapLineItemIdToRules(appliedDiscounts) {
    if (!appliedDiscounts) {
        return {};
    }
    return appliedDiscounts.reduce(function (acc, discount) {
        var _a;
        if (!discount.discountRule) {
            return acc;
        }
        (_a = discount.lineItemIds) === null || _a === void 0 ? void 0 : _a.forEach(function (lineItemId) {
            var _a;
            acc[lineItemId] = (_a = acc[lineItemId]) !== null && _a !== void 0 ? _a : [];
            acc[lineItemId].push(discount.discountRule.name.translated);
        });
        return acc;
    }, {});
}
function getCustomTextFields(lineItem) {
    var _a, _b;
    var textFields = ((_b = (_a = lineItem.catalogReference) === null || _a === void 0 ? void 0 : _a.options) === null || _b === void 0 ? void 0 : _b.customTextFields) || {};
    return Object.keys(textFields).map(function (key) { return ({
        title: key,
        value: textFields[key],
    }); });
}
export var getOptionsSelectionsValues = function (lineItem, customTextFields) {
    var _a;
    return ((_a = lineItem.descriptionLines) !== null && _a !== void 0 ? _a : [])
        .filter(function (descriptionLine) {
        var _a, _b, _c;
        var name = (_b = (_a = descriptionLine.name) === null || _a === void 0 ? void 0 : _a.translated) !== null && _b !== void 0 ? _b : (_c = descriptionLine.name) === null || _c === void 0 ? void 0 : _c.original;
        if (customTextFields.some(function (field) { return field.title === name; })) {
            return false;
        }
        var colorOption = getText(descriptionLine.colorInfo);
        var plainTextOption = getText(descriptionLine.plainText);
        return colorOption !== '' || plainTextOption !== '';
    })
        .map(function (descriptionLine, index) { return ({
        id: index,
        title: getText(descriptionLine.name),
        value: getText(descriptionLine.colorInfo) || getText(descriptionLine.plainText),
    }); });
};
var getText = function (text) { var _a, _b; return (_b = (_a = text === null || text === void 0 ? void 0 : text.translated) !== null && _a !== void 0 ? _a : text === null || text === void 0 ? void 0 : text.original) !== null && _b !== void 0 ? _b : ''; };
function mapLineItemToProduct(lineItem) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l;
    var image = lineItem.image ? getImageUrl(lineItem.image) : undefined;
    var media = image
        ? { url: image.filename, width: image.width, height: image.height, mediaType: 'PHOTO' }
        : { height: 0, width: 0, mediaType: 'PHOTO', url: '' };
    return {
        id: (_a = lineItem.catalogReference) === null || _a === void 0 ? void 0 : _a.catalogItemId,
        name: (_c = (_b = lineItem.productName) === null || _b === void 0 ? void 0 : _b.translated) !== null && _c !== void 0 ? _c : undefined,
        price: ((_d = lineItem.priceBeforeDiscounts) === null || _d === void 0 ? void 0 : _d.amount) ? Number(lineItem.priceBeforeDiscounts.amount) : 0,
        media: [media],
        weight: (_f = (_e = lineItem.physicalProperties) === null || _e === void 0 ? void 0 : _e.weight) !== null && _f !== void 0 ? _f : 0,
        productType: (_j = (_h = (_g = lineItem.itemType) === null || _g === void 0 ? void 0 : _g.preset) === null || _h === void 0 ? void 0 : _h.toLowerCase()) !== null && _j !== void 0 ? _j : (_l = (_k = lineItem.itemType) === null || _k === void 0 ? void 0 : _k.custom) === null || _l === void 0 ? void 0 : _l.toLowerCase(),
        customTextFields: getCustomTextFields(lineItem),
    };
}
//# sourceMappingURL=getLeanGQLCartFromSDK.js.map